var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card-text",
    [
      _c("yes_no", {
        key: "PAY_CACHE",
        attrs: { title: "PAY_CACHE" },
        on: { input: _vm.on_change_value },
        model: {
          value: _vm.item.pay_cache,
          callback: function ($$v) {
            _vm.$set(_vm.item, "pay_cache", $$v)
          },
          expression: "item.pay_cache",
        },
      }),
      _vm._v(" "),
      _c("yes_no", {
        key: "PAY_ONLINE",
        attrs: { title: "PAY_ONLINE" },
        on: { input: _vm.on_change_value },
        model: {
          value: _vm.item.pay_online,
          callback: function ($$v) {
            _vm.$set(_vm.item, "pay_online", $$v)
          },
          expression: "item.pay_online",
        },
      }),
      _vm._v(" "),
      _c("yes_no", {
        key: "PAY_TERMINAL",
        attrs: { title: "PAY_TERMINAL" },
        on: { input: _vm.on_change_value },
        model: {
          value: _vm.item.pay_terminal,
          callback: function ($$v) {
            _vm.$set(_vm.item, "pay_terminal", $$v)
          },
          expression: "item.pay_terminal",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }